<template>
  <div class="container">
    <div style="display: grid; font-size: 0.8em;">
      <div style="font-weight: bold">Justice 40 Initiative Layers</div>
      <div style="display: grid; grid-template-columns: 20px auto 1fr; margin: 2px; align-items: center;">
        <div style="background-color: #1550e0; height: 20px; width: 20px;"></div>
        <input type="checkbox" v-model="justice40Visible">
        <label>Climate and Economic Justice Screening Areas (CEJST)</label>
      </div>
      <div style="display: grid; grid-template-columns: 20px auto 1fr; margin: 2px;  align-items: center;">
        <div style="background-color: #f6216c; height: 20px; width: 20px;"></div>
        <input type="checkbox" v-model="etcVisible">
        <label>US DOT Equitable Transportation Areas (ETC)</label>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'overlaySelect',
    data: function () {
      return {
        etcVisible: false,
        justice40Visible: false,
      }
    },
    watch: {
      etcVisible: function () {
        this.$emit('etcChange', this.etcVisible)
      },
      justice40Visible: function () {
        this.$emit('justice40Change', this.justice40Visible)
      },
    },
  }
</script>
<style scoped>
  .container {
    grid-column: 1 / -1;
  }
    div.container {
    width: 290px;
    max-width: 100%;
    background-color: white;
    opacity: 0.9;
    padding: 7px;
    margin: 0 10px 10px 0;
    pointer-events: auto;
    border-radius: 15px;
  }

  input:active {
    background-color: red;
  }


</style>
